import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Props } from "./types";
import { RoleSelection } from "./roleSelection";
import { LanguageSelection } from "./languageSelection";
import styles from "./styles.scss";

function Member({ formData, error, hasFailed, hasSucceeded, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(styles.member, {
        [styles.failed]: hasFailed,
      })}
    >
      <div className={styles.group}>
        <input
          className={styles.input}
          disabled={hasSucceeded}
          placeholder={t("inviteMembers.emailPlaceholder")}
          value={formData.email}
          onChange={({ target }) => edit({ ...formData, email: target.value })}
        />
        {!hasSucceeded && error.invalidEmail && (
          <p className={styles.error}>{t("inviteMembers.invalidEmail")}</p>
        )}
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <input
            className={styles.input}
            disabled={hasSucceeded}
            placeholder={t("inviteMembers.lastNamePlaceholder")}
            value={formData.lastName}
            onChange={({ target }) =>
              edit({ ...formData, lastName: target.value })
            }
          />
          {!hasSucceeded &&
            (error.duplicatedInvitation ? (
              <p className={styles.error}>
                {t("inviteMembers.duplicatedInvitation")}
              </p>
            ) : (
              error.invalidLastName && (
                <p className={styles.error}>
                  {t("inviteMembers.invalidLastName")}
                </p>
              )
            ))}
        </div>
        <div className={styles.group}>
          <input
            className={styles.input}
            disabled={hasSucceeded}
            placeholder={t("inviteMembers.firstNamePlaceholder")}
            value={formData.firstName}
            onChange={({ target }) =>
              edit({ ...formData, firstName: target.value })
            }
          />
          {!hasSucceeded &&
            (error.duplicatedInvitation ? (
              <p className={styles.error}>
                {t("inviteMembers.duplicatedInvitation")}
              </p>
            ) : (
              error.invalidLastName && (
                <p className={styles.error}>
                  {t("inviteMembers.invalidFirstName")}
                </p>
              )
            ))}
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <RoleSelection
            placeholder={t("inviteMembers.rolePlaceholder")}
            isDisabled={hasSucceeded}
            isInvalid={hasFailed}
            selectedRole={formData.role || undefined}
            select={(role) => edit({ ...formData, role: role || null })}
          />
          {!hasSucceeded && error.emptyRole && (
            <p className={styles.error}>{t("inviteMembers.emptyRole")}</p>
          )}
        </div>
        <div className={styles.group}>
          <LanguageSelection
            placeholder={t("inviteMembers.languagePlaceholder")}
            isDisabled={hasSucceeded}
            isInvalid={hasFailed}
            selectedLanguage={formData.language}
            select={(language) => edit({ ...formData, language })}
          />
        </div>
      </div>
    </div>
  );
}

export { Member };
